import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root', // Esto hace que Angular lo registre automáticamente como un proveedor
})
@Pipe({
  name: 'timeFormat',
  standalone: false
})
export class TimeFormatPipe implements PipeTransform {
  /**
   * Transforma la hora eliminando el cero inicial si existe.
   * @param value - La hora como string o number.
   * @param includeMinutes - (Opcional) Si se deben incluir los minutos (true por defecto).
   */
  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Extraer la hora y los minutos usando destructuración
    const [hourPart, minutePart] = value.split(':');

    // Convertir la parte de la hora en un número
    const hour = parseInt(hourPart, 10);

    // Validar si la hora es un número válido entre 0 y 23
    if (isNaN(hour) || hour < 0 || hour > 23) {
      console.error('El valor de hora proporcionado no es válido');
      return '';
    }

    // Formatear la hora eliminando el cero inicial
    const formattedHour = hour.toString();

    // Devolver la hora con los minutos intactos
    return minutePart ? `${formattedHour}:${minutePart}` : formattedHour;
  }
}
